import $ from 'jquery';
import aitl from 'aitl';

export default function SimplePaging(pgInfo) {

    var fireChangeTimeOut = 300;
    var fireChangeTimer = null;

    var page = pgInfo.currentPage;
    var itemCount = pgInfo.totalItemCount;
    var pageSize = pgInfo.pageSize;
    var totalPage = calTotalPage(itemCount, pageSize);

    var pageChange = pgInfo.pageChange;
    var textChange = pgInfo.textChange;

    setDisplayText();
    var pgOlay = aitl.Overlay();
    var $content = $("<div>").css({ position: "relative", width: "300px", height: "30px", margin: "0 auto", "text-align": "center", color: "black" });
    var $pgInput = $("<input>").attr("type", "text").css({ position: "relative", width: "50px", height: "30px" }).val(page);
    var $goBtn = $("<input>").attr("type", "button").css({ position: "relative", width: "100px", height: "30px" }).val("Go");
    $goBtn.click(function () {
        var newPage = $pgInput.val();
        setPage(newPage);
        pgOlay.hide();
    });
    $content.append($pgInput).append("<br/>").append($goBtn);
    pgOlay.append($content);
    pgOlay.setContentRatio(80, 80);

    function calTotalPage(itemCount, pageSize) {
        return Math.ceil(itemCount / pageSize);
    }

    function setDisplayText() {
        if (textChange) {
            textChange(page, totalPage);
        }
    }

    function setPage(newPage) {
        if (newPage < 1) {
            newPage = 1;
        }
        if (newPage > totalPage) {
            newPage = totalPage;
        }
        page = newPage;
        setDisplayText();

        if (fireChangeTimer !== null) {
            clearTimeout(fireChangeTimer);
        }
        fireChangeTimer = setTimeout(function () {
            pageChange(page);
            fireChangeTimer = null;
        }, fireChangeTimeOut);

    }

    return {
        resetParams: function (pageNew, pageSizeNew, itemCountNew) {
            page = pageNew;
            pageSize = pageSizeNew;
            itemCount = itemCountNew;
            totalPage = calTotalPage(itemCount, pageSize);
            setDisplayText();
        },
        getTotalPage: function () {
            return totalPage;
        },
        getCurrentPage: function () {
            return page;
        },
        setPage: setPage,
        gotoLastPage: function () {
            setPage(totalPage);
        },
        gotoFirstPage: function () {
            setPage(1);
        },
        prevPage: function () {
            setPage(page - 1);
        },
        nextPage: function () {
            setPage(page + 1);
        },
        showPageEntry: function () {
            pgOlay.show();
        },
        destroy: function () {
            pgOlay.destroy();
        }
    };
}